import { BhtpChatConfig } from '@bhtravel/chat-web-component/dist/types/models/bhtp-chat-config.model';
import { BhtpChatInputs } from '@bhtravel/chat-web-component/dist/types/models/bhtp-chat-inputs.model';
import { graphql, useStaticQuery } from 'gatsby';
import React from 'react';
import { AppConfig } from '../../../environment/app-config.model';
import { ChatBhtpContainerComponent } from '../../chat-web-component/chat-web-component';

export const ChatEnvironmentStaticQuery = graphql`query ChatEnvironmentStaticQuery {
    environment: environmentJson {
        liveChatButtonId
        liveChatDeploymentId
        liveChatOrgId
        liveChatOrgUrl
        liveChatUrl
        liveChatApiVersion
    }
}`;

interface EnvironmentStaticQueryResult {
    environment: AppConfig;
}

const ChatComponent = (): React.ReactElement => {
    const { environment } = useStaticQuery<EnvironmentStaticQueryResult>(ChatEnvironmentStaticQuery);

    const chatConfig: BhtpChatConfig = {
        liveChatButtonId: environment.liveChatButtonId,
        liveChatDeploymentId: environment.liveChatDeploymentId,
        liveChatOrgId: environment.liveChatOrgId,
        liveChatOrgUrl: environment.liveChatOrgUrl,
        liveChatUrl: environment.liveChatUrl,
        apiVersion: environment.liveChatApiVersion
    };

    const chatInputs: BhtpChatInputs = {
        accountId: '',
        caseSubject: '',
        caseStatus: 'New',
        caseOrigin: 'Chat',
        displayName: ''
    };

    return (
        <div className='fixed right-8 bottom-8 xl:right-32 xl:bottom-24'>
            <ChatBhtpContainerComponent
                bhtpChatConfig={chatConfig}
                bhtpChatInputs={chatInputs}
                debug={false}>
            </ChatBhtpContainerComponent>
        </div>
    );
};

export default ChatComponent;
